import {
  Box,
  Button,
  Container,
  IconButton,
  InputAdornment,
  makeStyles,
  TextField,
  ThemeProvider,
  Typography,
} from "@material-ui/core";
import {
  CheckCircleRounded,
  FiberManualRecord,
  Visibility,
  VisibilityOff,
} from "@material-ui/icons";
import { useTranslate } from "ra-core";
import React, { useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import sfLogo from "../../assets/icons/logologin.png";
import useForgotPassword from "../../hooks/useForgotPassword";
import theme from "../../theme";
const useStyles = makeStyles((theme) => ({
  allContainer: {
    position: "absolute",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: theme.lightGray2,
    borderColor: "transparent",
    display: "grid",
    placeItems: "center",
  },
  button: {
    marginTop: 10,
    fontSize: 18,
    boxSizing: "border-box",
    width: 352,
    height: 49,
  },
  alignCenterContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
  },
  sfLogo: {
    width: 200,
    height: 86,
    marginTop: 40,
  },
  headerText: {
    fontSize: 18,
    fontWeight: 600,
    color: "#404040",
    marginTop: 30,
    width: 352,
    boxSizing: "border-box",
  },
  sencondHeaderText: {
    fontSize: 18,
    fontWeight: 600,
    color: "#404040",
    width: 352,
    marginTop: 30,
    boxSizing: "border-box",
  },
  containerConditionPassword: {
    display: "flex",
    justifyContent: "left",
    width: "100%",
    marginLeft: 60,
  },
  conditionPasswordText: {
    fontSize: 16,
    fontWeight: "normal",
    color: theme.darkGray + "80",
  },
  passConditionPasswordText: {
    fontSize: 16,
    fontWeight: "normal",
    color: theme.green,
  },
  iconConditionPassword: {
    minWidth: 9,
    width: 9,
    marginRight: 3,
    color: theme.darkGray + "80",
  },
  passIconConditionPassword: {
    minWidth: 13,
    width: 13,
    marginRight: 3,
    color: theme.green,
  },
  helperText: {
    margin: 0,
    padding: 0,
    textAlign: "right",
    fontSize: 12,
    marginTop: 2,
    color: theme.red,
  },
  textField: {
    marginTop: 10,
    boxSizing: "border-box",
    width: 352,
  },
  subHeader: {
    textAlign: "left",
    width: "100%",
    marginLeft: 60,
    marginTop: 10,
    color: theme.darkGray,
  },
  cancelButton: { fontSize: 18, marginTop: 10, color: theme.darkGray },
  paper: { backgroundColor: "white", borderRadius: 8, width: 458, height: 585 },
}));
function ResetPassword() {
  const classes = useStyles();
  const location = useLocation();
  const history = useHistory();
  const translate = useTranslate();
  const [newPassword, setNewPassword] = useState("");
  const [showPassword, setShowPassword] = useState("");
  const [confirmNewPassword, setConfirmNewPassword] = useState("");
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [errorTextField, setErrorTextField] = useState(false);
  const { addNewPassword } = useForgotPassword();

  return (
    <ThemeProvider theme={theme}>
      <Box className={classes.allContainer}>
        <Box className={classes.alignCenterContainer}>
          <Box className={classes.paper}>
            <Container
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <img src={sfLogo} alt="sflogo" className={classes.sfLogo} />

              <Typography className={classes.headerText} align="left">
                {translate("ra.text.forgotPassword.setNewPassword")}
              </Typography>

              <TextField
                id="standard-basic"
                placeholder={translate("ra.text.forgotPassword.newPassword")}
                type={showPassword ? "text" : "password"}
                className={classes.textField}
                variant="outlined"
                onChange={(e) => {
                  setNewPassword(e.target.value);
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={() => setShowPassword(!showPassword)}
                      >
                        {showPassword ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
              <Typography className={classes.subHeader}>
                {translate("ra.text.forgotPassword.newPasswordCondition")}
              </Typography>
              <Box className={classes.containerConditionPassword}>
                {newPassword.length > 8 ? (
                  <CheckCircleRounded
                    className={classes.passIconConditionPassword}
                  />
                ) : (
                  <FiberManualRecord
                    className={classes.iconConditionPassword}
                  />
                )}
                <Typography
                  className={
                    newPassword.length > 8
                      ? classes.passConditionPasswordText
                      : classes.conditionPasswordText
                  }
                >
                  {translate("ra.text.forgotPassword.newPasswordMinimum")}
                </Typography>
              </Box>

              <Typography className={classes.sencondHeaderText} align="left">
                {translate("ra.text.forgotPassword.confirmPassword")}
              </Typography>

              <TextField
                id="standard-basic"
                placeholder={translate(
                  "ra.text.forgotPassword.confirmPassword"
                )}
                error={errorTextField}
                className={classes.textField}
                helperText={
                  errorTextField
                    ? translate("ra.text.forgotPassword.passwordError")
                    : ""
                }
                FormHelperTextProps={{ className: classes.helperText }}
                type={showConfirmPassword ? "text" : "password"}
                variant="outlined"
                onChange={(e) => {
                  setConfirmNewPassword(e.target.value);
                  if (
                    e.target.value.length >= newPassword.length &&
                    e.target.value !== newPassword
                  ) {
                    setErrorTextField(true);
                  } else if (e.target.value === newPassword) {
                    setErrorTextField(false);
                  }
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={() =>
                          setShowConfirmPassword(!showConfirmPassword)
                        }
                      >
                        {showConfirmPassword ? (
                          <Visibility />
                        ) : (
                          <VisibilityOff />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
              <br />

              <Button
                variant="contained"
                color="primary"
                disabled={newPassword === confirmNewPassword ? false : true}
                className={classes.button}
                onClick={async () => {
                  const [result, error] = await addNewPassword(
                    location.state?.username,
                    newPassword,
                    location.state?.refCode
                  );
                  if (error) {
                    setErrorTextField(true);
                  }
                  if (result) {
                    history.push({ pathname: "/reset-password-success" });
                  }
                }}
              >
                {translate("ra.action.submit")}
              </Button>
              <Button
                onClick={() => history.replace("/login")}
                className={classes.cancelButton}
              >
                {translate("ra.action.cancel")}
              </Button>
            </Container>
          </Box>
        </Box>
      </Box>
    </ThemeProvider>
  );
}

export default ResetPassword;
